import React, { useState, useEffect } from "react";
import { Star, Loader2, CalendarCheck, Quote } from "lucide-react";
import api from "../lib/api";
import ConsultationModal from "./ConsultationModal";

const Stars = ({ value, size = 16, onChange }) => (
  <span className={`stars ${onChange ? "interactive" : ""}`}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} onClick={onChange ? () => onChange(n) : undefined}
        fill={n <= value ? "#f5a623" : "none"} stroke={n <= value ? "#f5a623" : "#c7d1dc"} />
    ))}
  </span>
);

const emptyForm = { name: "", company: "", rating: 5, comment: "" };

const ServiceReviews = () => {
  const [data, setData] = useState({ reviews: [], average: 0, count: 0 });
  const [form, setForm] = useState(emptyForm);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [modal, setModal] = useState(false);

  const load = () => api.get("/service-reviews").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  useEffect(() => {
    const handler = () => setModal(true);
    window.addEventListener("open-consultation", handler);
    return () => window.removeEventListener("open-consultation", handler);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/service-reviews", form);
      setForm(emptyForm); setDone(true); load();
      setTimeout(() => setDone(false), 4000);
    } catch (err) { /* noop */ }
    finally { setBusy(false); }
  };

  return (
    <section className="svc-reviews" id="testimonials">
      <div className="container">
        <div className="section-head">
          <span className="kicker">Client Testimonials</span>
          <h2>What our clients say</h2>
          <p>Carriers and businesses share their experience with Flying Fleet Dispatch services.</p>
        </div>

        <div className="svc-rating-banner">
          <div className="svc-avg">{data.average || "–"}</div>
          <div>
            <Stars value={Math.round(data.average)} size={20} />
            <div className="svc-avg-label">Based on {data.count} client reviews</div>
          </div>
          <button className="btn btn-primary svc-book" onClick={() => setModal(true)}>
            <CalendarCheck size={16} /> Book a Consultation
          </button>
        </div>

        <div className="svc-review-grid">
          {data.reviews.map((r) => (
            <div className="svc-review-card" key={r.id}>
              <Quote size={22} className="svc-quote" />
              <p className="svc-comment">{r.comment}</p>
              <div className="svc-review-foot">
                <div>
                  <div className="svc-name">{r.name}</div>
                  {r.company && <div className="svc-company">{r.company}</div>}
                </div>
                <Stars value={r.rating} />
              </div>
            </div>
          ))}
        </div>

        <form className="svc-review-form" onSubmit={submit}>
          <h3>Leave a review of our service</h3>
          {done && <div className="review-done">Thank you for your feedback!</div>}
          <div className="form-row">
            <div className="field"><label>Your Name</label><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" /></div>
            <div className="field"><label>Company (optional)</label><input value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} placeholder="Your company" /></div>
          </div>
          <div className="field"><label>Rating</label><Stars value={form.rating} size={26} onChange={(n) => setForm({ ...form, rating: n })} /></div>
          <div className="field"><label>Your review</label><textarea value={form.comment} onChange={(e) => setForm({ ...form, comment: e.target.value })} placeholder="How was your experience?"></textarea></div>
          <button className="btn btn-primary" disabled={busy}>{busy ? <Loader2 size={16} className="spin" /> : null} Submit Review</button>
        </form>
      </div>

      <ConsultationModal open={modal} onClose={() => setModal(false)} />
    </section>
  );
};

export default ServiceReviews;
